import styles from './profileitem.module.sass';
import cn from 'classnames';
import { ReactElement } from 'react';
import { Box } from '../Box';
import { FlexWrapper } from '../FlexWrapper';
import { Text } from '../Text';

interface ProfileItemProps extends React.HTMLAttributes<HTMLDivElement> {
    avatar: ReactElement;
    active?: boolean;
    cta?: string;
    compact?: boolean;
}

export const ProfileItem = ({ children, avatar, active, cta, compact, ...props }: ProfileItemProps) => {
    return (
        <Box
            theme="light"
            padding="0"
            {...props}
            className={cn(
                styles.profile,
                active && styles.active,
                compact && styles.compact,
                props.className,
                props.onClick && styles.clickable
            )}
            // {...props.onClick && {style: {cursor: 'pointer'}}}
        >
            <FlexWrapper justifyContent="between" alignItems="center" paddingEnd="2x" paddingStart="2x">
                {avatar}
                {cta && (
                    <Text as="span" size="14" color="brand" className={styles.link}>
                        {cta}
                    </Text>
                )}
            </FlexWrapper>
        </Box>
    );
};
